import React, { useRef } from 'react';
import { Trash2, Video, ExternalLink, User, FileUp, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

const AdminControlBar = ({
  book,
  deleting,
  onDeleteBook,
  onShowTrailerUpload,
  onDeleteTrailer,
  showLinksEditor,
  onToggleLinksEditor,
  showMetaEditor,
  onToggleMetaEditor,
  reuploadingFile = false,
  onReuploadBookFile,
}) => {
  const fileInputRef = useRef(null);
  const hasFile = !!book?.book_file_url;
  const reuploadLabel = hasFile ? 'Re-upload Book File' : 'Upload Book File';

  return (
    <>
      <Button
        onClick={onDeleteBook}
        disabled={deleting}
        variant="destructive"
        className="bg-red-600 hover:bg-red-700"
        data-testid="delete-book-btn"
      >
        <Trash2 className="mr-2 h-4 w-4" />
        {deleting ? 'Deleting...' : 'Delete Book'}
      </Button>
      <Button
        onClick={onShowTrailerUpload}
        variant="secondary"
        className="bg-purple-600 hover:bg-purple-700"
        data-testid="manage-trailer-btn"
      >
        <Video className="mr-2 h-4 w-4" />
        {book.trailer_url ? 'Replace Trailer' : 'Add Trailer'}
      </Button>
      {book.trailer_url && (
        <Button
          onClick={onDeleteTrailer}
          variant="outline"
          className="border-red-500 text-red-500 hover:bg-red-500/10"
          data-testid="remove-trailer-btn"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          Remove Trailer
        </Button>
      )}
      <Button
        onClick={onToggleLinksEditor}
        variant="secondary"
        className="bg-amber-600 hover:bg-amber-700"
        data-testid="manage-links-btn"
      >
        <ExternalLink className="mr-2 h-4 w-4" />
        {showLinksEditor ? 'Hide Links' : 'Add/Edit Purchase Links'}
      </Button>
      <Button
        onClick={onToggleMetaEditor}
        variant="secondary"
        className="bg-teal-600 hover:bg-teal-700"
        data-testid="manage-meta-btn"
      >
        <User className="mr-2 h-4 w-4" />
        {showMetaEditor ? 'Hide' : 'Edit Book / Genres / Bio'}
      </Button>
      {/* Re-upload book file (PDF/EPUB) */}
      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,.epub,application/pdf,application/epub+zip"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f && onReuploadBookFile) onReuploadBookFile(f);
          if (fileInputRef.current) fileInputRef.current.value = '';
        }}
        className="hidden"
        data-testid="reupload-book-file-input"
      />
      <Button
        onClick={() => fileInputRef.current?.click()}
        disabled={reuploadingFile}
        variant="secondary"
        className={hasFile ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-orange-600 hover:bg-orange-700'}
        data-testid="reupload-book-file-btn"
        title={hasFile ? 'Replace the readable PDF/EPUB on the server' : 'No book file is attached. Upload one now.'}
      >
        {hasFile ? (
          <FileUp className="mr-2 h-4 w-4" />
        ) : (
          <AlertTriangle className="mr-2 h-4 w-4" />
        )}
        {reuploadingFile ? 'Uploading...' : reuploadLabel}
      </Button>
    </>
  );
};

export default AdminControlBar;
